angular.module('myApp')


.controller('FooterCtrl', ['$scope', '$timeout','$location',function( $scope, $timeout,$location) {
}])